export const Types = {
    SAVE_LIST_REQUEST: 'SAVE_LIST_REQUEST',
  }
  